import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { Themes } from './themes.enum';

@Injectable({
  providedIn: 'root'
})
export class ThemesService {
  private readonly theme$ = new BehaviorSubject<Themes | null>(null);

  public getCurrentTheme(): Themes | null {
    return this.theme$.value;
  }

  public themeChanged(): Observable<string> {
    return this.theme$.pipe(
      filter((theme): theme is Themes => theme !== null),
      map((theme) => `${theme}.css`)
    );
  }

  public changeTheme(theme: Themes): void {
    this.theme$.next(theme);
  }
}
